export default __webpack_public_path__ + "assets/images/32ce4948330f7d79ea5987f596558bdf.svg";